import constantFactory from "@gaoding/constant-factory";

export const {
  LOCAL_STORAGE_KEY,
  LOCAL_STORAGE_KEY_LIST,
  LOCAL_STORAGE_KEY_MAP,
  LOCAL_STORAGE_KEY_ITEM_MAP,
} = constantFactory("LOCAL_STORAGE_KEY", [
  {
    key: "HB_PREFERENCE_SETTING_GUIDE",
    label: "偏好设置引导",
    value: "hb_preference_setting_guide",
  },
  {
    key: "UPDATE_LAST_BOARDS",
    label: "更新最近采集的画板",
    value: "updateLastBoards",
  },
  {
    key: "BOARD_HISTORY",
    label: "画板详情浏览历史记录",
    value: "boardHistory",
  },
  {
    key: "LAST_UNCLASSIFIED_BOARD",
    label: "最近未分类画板",
    value: "lastUnclassifiedBoard",
  },
  {
    key: "APP_STORE",
    label: "应用状态",
    value: "appStore",
  },
  {
    key: "HUABAN_PAGE_SETTING",
    label: "偏好设置",
    value: "huaban-page-setting",
  },
  {
    key: "HB_NOTIFICATION_SYSTEM_DM",
    label: "系统通知消息横幅关闭信息",
    value: "hb-notification-system-dm",
  },
  {
    key: "HB_HEADER_NAV_TAG",
    label: "导航栏链接的红色标识",
    value: "hb-header-nav-tag",
  },
  {
    key: "HB_DOWNLOAD_LIST",
    label: "下载记录浮窗",
    value: "hb-download-list",
  },
  {
    key: "HB_DOWNLOADED_RECORD",
    label: "下载记录浮窗",
    value: "hb-downloaded-record",
  },
  {
    key: "HB_MUTI_SUBJECT_TIP",
    label: "多授权主体提醒",
    value: "hb_muti_subject_tip",
  },
  {
    key: "HB_SEARCH_RECOMMEND",
    label: "搜索推荐主题",
    value: "hb_search_recommend",
  },
  {
    key: "HB_BIND_PHONE_GUIDE",
    label: "绑定手机号引导",
    value: "hb_bind_phone_guide",
  },
  {
    key: "HB_PIN_DETAIL_GAODING_TIP",
    label: "采集详情页去稿定编辑器提示",
    value: "hb_pin_detail_gaoding_tip",
  },
  {
    key: "HB_PIN_SEARCH_SIMILAR_TIP",
    lable: "采集搜相似提示",
    value: "hb_pin_search_similar_tip",
  },
  {
    //对应的需求： https://doc.huanleguang.com/pages/viewpage.action?pageId=374307227
    key: "HB_AUTO_POTENTIAL_CLUES",
    lable: "潜在线索自动推送条件",
    value: "hb_autoPotentialClues",
  },
  {
    // AI工具内容免责声明
    key: "HB_AI_TOOLS_CONTENT_DISCLAIMER",
    lable: "AI工具内容免责声明",
    value: "hb_aiToolsContentDisclaimer",
  },
  {
    // AI工具
    key: "HB_AI_RANDOM_TOOLS",
    lable: "AI工具",
    value: "hb_aiRandomTools",
  },
  {
    // 下载点击次数记录
    key: "HB_DOWNLOAD_CLICK_COUNT",
    lable: "下载点击次数",
    value: "hb_download_click_count",
  },
  {
    // 多人画板管理
    key: "HB_MULTI_BOARD",
    lable: "多人画板引导提示",
    value: "hb_multi_board",
  },
]);
